import React, { useContext } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { UserContext } from "./UserContext";

export const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const { user, loading } = useContext(UserContext);

  if (loading.loading || !loading.loaded) return null;

  return <Route {...rest}>{user.username !== "" ? children : <Redirect to="/login" />}</Route>;
};
